import { OscillatorSettings } from '../../../synth';
import { DawNote } from '../../../types';

export interface Project {
  id: string;
  name: string;
  savedAt: number;
  oscillators: OscillatorSettings[];
  bpm: number;
  measures: number;
  notes: DawNote[];
  loop: boolean;
}

// steps = 16th notes  |  quarter = 4  |  8th = 2  |  half = 8  |  whole = 16
// 4 steps/beat × 4 beats/bar = 16 steps/bar

// ── Twinkle Twinkle Little Star — 12 bars (full song) ────────────────────────
const twinkleNotes: DawNote[] = [
  { id: 'tt-1',  note: 'C4', startStep:   0, durationSteps: 4 },
  { id: 'tt-2',  note: 'C4', startStep:   4, durationSteps: 4 },
  { id: 'tt-3',  note: 'G4', startStep:   8, durationSteps: 4 },
  { id: 'tt-4',  note: 'G4', startStep:  12, durationSteps: 4 },
  { id: 'tt-5',  note: 'A4', startStep:  16, durationSteps: 4 },
  { id: 'tt-6',  note: 'A4', startStep:  20, durationSteps: 4 },
  { id: 'tt-8',  note: 'F4', startStep:  32, durationSteps: 4 },
  { id: 'tt-9',  note: 'F4', startStep:  36, durationSteps: 4 },
  { id: 'tt-10', note: 'E4', startStep:  40, durationSteps: 4 },
  { id: 'tt-11', note: 'E4', startStep:  44, durationSteps: 4 },
  { id: 'tt-12', note: 'D4', startStep:  48, durationSteps: 4 },
  { id: 'tt-13', note: 'D4', startStep:  52, durationSteps: 4 },
  { id: 'tt-14', note: 'C4', startStep:  56, durationSteps: 8 },
  { id: 'tt-15', note: 'G4', startStep:  64, durationSteps: 4 },
  { id: 'tt-16', note: 'G4', startStep:  68, durationSteps: 4 },
  { id: 'tt-17', note: 'F4', startStep:  72, durationSteps: 4 },
  { id: 'tt-18', note: 'F4', startStep:  76, durationSteps: 4 },
  { id: 'tt-19', note: 'E4', startStep:  80, durationSteps: 4 },
  { id: 'tt-20', note: 'E4', startStep:  84, durationSteps: 4 },
  { id: 'tt-21', note: 'D4', startStep:  88, durationSteps: 8 },
  { id: 'tt-22', note: 'G4', startStep:  96, durationSteps: 4 },
  { id: 'tt-23', note: 'G4', startStep: 100, durationSteps: 4 },
  { id: 'tt-24', note: 'F4', startStep: 104, durationSteps: 4 },
  { id: 'tt-25', note: 'F4', startStep: 108, durationSteps: 4 },
  { id: 'tt-26', note: 'E4', startStep: 112, durationSteps: 4 },
  { id: 'tt-27', note: 'E4', startStep: 116, durationSteps: 4 },
  { id: 'tt-28', note: 'D4', startStep: 120, durationSteps: 8 },
  { id: 'tt-29', note: 'C4', startStep: 128, durationSteps: 4 },
  { id: 'tt-30', note: 'C4', startStep: 132, durationSteps: 4 },
  { id: 'tt-31', note: 'G4', startStep: 136, durationSteps: 4 },
  { id: 'tt-32', note: 'G4', startStep: 140, durationSteps: 4 },
  { id: 'tt-33', note: 'A4', startStep: 144, durationSteps: 4 },
  { id: 'tt-34', note: 'A4', startStep: 148, durationSteps: 4 },
  { id: 'tt-35', note: 'G4', startStep: 152, durationSteps: 8 },
  { id: 'tt-36', note: 'F4', startStep: 160, durationSteps: 4 },
  { id: 'tt-37', note: 'F4', startStep: 164, durationSteps: 4 },
  { id: 'tt-38', note: 'E4', startStep: 168, durationSteps: 4 },
  { id: 'tt-39', note: 'E4', startStep: 172, durationSteps: 4 },
  { id: 'tt-40', note: 'D4', startStep: 176, durationSteps: 4 },
  { id: 'tt-41', note: 'D4', startStep: 180, durationSteps: 4 },
  { id: 'tt-42', note: 'C4', startStep: 184, durationSteps: 8 },
  { id: 'n-1772788280142-k8bt4', note: 'G3', startStep:   2, durationSteps: 1 },
  { id: 'n-1772788280803-jr9yk', note: 'G3', startStep:   6, durationSteps: 1 },
  { id: 'n-1772788284012-i1qsa', note: 'D4', startStep:  10, durationSteps: 1 },
  { id: 'n-1772788286563-cyouh', note: 'F4', startStep:  14, durationSteps: 1 },
  { id: 'n-1772788287215-8hipe', note: 'F4', startStep:  10, durationSteps: 1 },
  { id: 'n-1772788288670-bxvd9', note: 'D4', startStep:  14, durationSteps: 1 },
  { id: 'n-1772788307750-95ce2', note: 'C5', startStep:  18, durationSteps: 1 },
  { id: 'n-1772788308426-qhkzz', note: 'D5', startStep:  19, durationSteps: 1 },
  { id: 'n-1772788309146-rmvpl', note: 'E5', startStep:  20, durationSteps: 1 },
  { id: 'n-1772788309867-j71r7', note: 'F5', startStep:  21, durationSteps: 1 },
  { id: 'n-1772788310602-0bdwp', note: 'G5', startStep:  22, durationSteps: 1 },
  { id: 'n-1772788311269-1apoj', note: 'A5', startStep:  23, durationSteps: 1 },
  { id: 'n-1772788312073-m3aii', note: 'G5', startStep:  24, durationSteps: 1 },
  { id: 'n-1772788312776-vjoru', note: 'F5', startStep:  25, durationSteps: 1 },
  { id: 'n-1772788319018-etiiu', note: 'G4', startStep:  24, durationSteps: 8 },
  { id: 'n-1772788335696-rv6b9', note: 'E5', startStep:  26, durationSteps: 1 },
  { id: 'n-1772788336509-bfdf7', note: 'D5', startStep:  27, durationSteps: 1 },
  { id: 'n-1772788337242-yy5wo', note: 'C5', startStep:  28, durationSteps: 1 },
  { id: 'n-1772788337962-5q22a', note: 'B4', startStep:  29, durationSteps: 1 },
  { id: 'n-1772788338787-6xf6r', note: 'A4', startStep:  30, durationSteps: 1 },
  { id: 'n-1772788348583-46fzc', note: 'B4', startStep:  35, durationSteps: 1 },
  { id: 'n-1772788353742-01fzl', note: 'G4', startStep:  39, durationSteps: 1 },
  { id: 'n-1772788368212-ingyo', note: 'D4', startStep:  33, durationSteps: 1 },
  { id: 'n-1772788371063-x6kxh', note: 'B3', startStep:  37, durationSteps: 1 },
  { id: 'n-1772788377151-iuk95', note: 'B4', startStep:  34, durationSteps: 1 },
  { id: 'n-1772788378088-ze3j4', note: 'D4', startStep:  32, durationSteps: 1 },
  { id: 'n-1772788378772-wd0ne', note: 'B3', startStep:  36, durationSteps: 1 },
  { id: 'n-1772788379372-7i3kq', note: 'G4', startStep:  38, durationSteps: 1 },
  { id: 'n-1772788388277-zqtj9', note: 'C4', startStep:  40, durationSteps: 2 },
  { id: 'n-1772788389887-jc2zz', note: 'B3', startStep:  42, durationSteps: 2 },
  { id: 'n-1772788391261-6svye', note: 'A3', startStep:  44, durationSteps: 2 },
  { id: 'n-1772788394021-6ci52', note: 'G3', startStep:  46, durationSteps: 2 },
  { id: 'n-1772788395949-064b9', note: 'F3', startStep:  48, durationSteps: 2 },
  { id: 'n-1772788397187-hqc1z', note: 'E3', startStep:  50, durationSteps: 2 },
  { id: 'n-1772788398536-y0gip', note: 'D3', startStep:  52, durationSteps: 4 },
  { id: 'n-1772788425741-82m86', note: 'C3', startStep:  56, durationSteps: 8 },
  { id: 'n-1772788441205-613dv', note: 'F4', startStep:  66, durationSteps: 1 },
  { id: 'n-1772788455292-hjbat', note: 'F4', startStep:  70, durationSteps: 1 },
  { id: 'n-1772788464255-jzq7c', note: 'A4', startStep:  74, durationSteps: 1 },
  { id: 'n-1772788465701-yufts', note: 'A4', startStep:  78, durationSteps: 1 },
  { id: 'n-1772788489471-gcj4h', note: 'C6', startStep:  56, durationSteps: 8 },
  { id: 'n-1772788492703-t9sku', note: 'B5', startStep:  54, durationSteps: 2 },
  { id: 'n-1772788499541-a70um', note: 'B4', startStep:  48, durationSteps: 1 },
  { id: 'n-1772788500539-yst3z', note: 'D5', startStep:  50, durationSteps: 1 },
  { id: 'n-1772788501477-x32lb', note: 'G5', startStep:  52, durationSteps: 1 },
  { id: 'n-1772788520700-ds01j', note: 'C6', startStep:  68, durationSteps: 1 },
  { id: 'n-1772788525052-0wc3t', note: 'A5', startStep:  67, durationSteps: 1 },
  { id: 'n-1772788527415-2agbu', note: 'A5', startStep:  71, durationSteps: 1 },
  { id: 'n-1772788528176-7syqh', note: 'B5', startStep:  72, durationSteps: 1 },
  { id: 'n-1772788534915-9r4wd', note: 'G5', startStep:  75, durationSteps: 1 },
  { id: 'n-1772788535831-8qds3', note: 'G5', startStep:  79, durationSteps: 1 },
  { id: 'n-1772788537041-f8z1c', note: 'A5', startStep:  73, durationSteps: 1 },
  { id: 'n-1772788537840-isidh', note: 'A5', startStep:  77, durationSteps: 1 },
  { id: 'n-1772788542754-ml7mm', note: 'A5', startStep:  81, durationSteps: 1 },
  { id: 'n-1772788545798-oesp2', note: 'G5', startStep:  83, durationSteps: 1 },
  { id: 'n-1772788546661-czaux', note: 'F5', startStep:  85, durationSteps: 1 },
  { id: 'n-1772788547382-cczvv', note: 'A5', startStep:  87, durationSteps: 1 },
  { id: 'n-1772788548033-dndj9', note: 'D5', startStep:  88, durationSteps: 1 },
  { id: 'n-1772788548761-40rc9', note: 'G5', startStep:  90, durationSteps: 1 },
  { id: 'n-1772788549344-owu9h', note: 'E5', startStep:  92, durationSteps: 1 },
  { id: 'n-1772788551724-piban', note: 'D5', startStep:  93, durationSteps: 1 },
  { id: 'n-1772788552338-p62vf', note: 'C5', startStep:  94, durationSteps: 2 },
  { id: 'n-1772788563398-ipiwi', note: 'E5', startStep:  96, durationSteps: 4 },
  { id: 'n-1772788565142-xqp6c', note: 'F5', startStep: 100, durationSteps: 2 },
  { id: 'n-1772788567123-k7wua', note: 'F5', startStep: 102, durationSteps: 1 },
  { id: 'n-1772788569606-lrzo0', note: 'F5', startStep: 103, durationSteps: 1 },
  { id: 'n-1772788572353-36vxd', note: 'G5', startStep: 104, durationSteps: 1 },
  { id: 'n-1772788572957-w0ihb', note: 'G5', startStep: 105, durationSteps: 1 },
  { id: 'n-1772788573452-4gnhi', note: 'G5', startStep: 106, durationSteps: 2 },
  { id: 'n-1772788574933-7cy4j', note: 'A5', startStep: 108, durationSteps: 4 },
  { id: 'n-1772788578785-1hqxk', note: 'C6', startStep: 112, durationSteps: 1 },
  { id: 'n-1772788579451-a96fg', note: 'C6', startStep: 113, durationSteps: 1 },
  { id: 'n-1772788580106-72678', note: 'C6', startStep: 114, durationSteps: 1 },
  { id: 'n-1772788580720-0e3v2', note: 'C6', startStep: 115, durationSteps: 1 },
  { id: 'n-1772788586083-b03sf', note: 'B5', startStep: 116, durationSteps: 1 },
  { id: 'n-1772788589886-8n6s9', note: 'A5', startStep: 118, durationSteps: 1 },
  { id: 'n-1772788590366-mdmu8', note: 'B5', startStep: 119, durationSteps: 1 },
  { id: 'n-1772788590868-f1hkn', note: 'C6', startStep: 120, durationSteps: 8 },
  { id: 'n-1772788647844-bwynn', note: 'D5', startStep: 120, durationSteps: 8 },
  { id: 'n-1772788676021-jzkez', note: 'A3', startStep: 130, durationSteps: 1 },
  { id: 'n-1772788677297-4k2l3', note: 'G3', startStep: 134, durationSteps: 1 },
  { id: 'n-1772788679540-4zv07', note: 'F3', startStep: 138, durationSteps: 1 },
  { id: 'n-1772788680792-3gm9m', note: 'D3', startStep: 142, durationSteps: 1 },
  { id: 'n-1772788683244-gyi7s', note: 'C3', startStep: 144, durationSteps: 4 },
  { id: 'n-1772788685702-3c5do', note: 'D3', startStep: 148, durationSteps: 4 },
  { id: 'n-1772788687489-77fox', note: 'E3', startStep: 152, durationSteps: 4 },
  { id: 'n-1772788690384-xya1p', note: 'F3', startStep: 156, durationSteps: 4 },
  { id: 'n-1772788699793-awq0j', note: 'A4', startStep: 162, durationSteps: 1 },
  { id: 'n-1772788701329-53v7p', note: 'B4', startStep: 166, durationSteps: 1 },
  { id: 'n-1772788703691-r21co', note: 'G4', startStep: 170, durationSteps: 1 },
  { id: 'n-1772788704737-mf72m', note: 'A4', startStep: 174, durationSteps: 1 },
  { id: 'n-1772788720415-ua7h9', note: 'B4', startStep: 176, durationSteps: 1 },
  { id: 'n-1772788720742-v0zqe', note: 'B4', startStep: 177, durationSteps: 1 },
  { id: 'n-1772788721129-aysgj', note: 'B4', startStep: 178, durationSteps: 1 },
  { id: 'n-1772788729596-gtuwi', note: 'C5', startStep: 184, durationSteps: 8 },
  { id: 'n-1772788738881-m2tgf', note: 'B4', startStep: 180, durationSteps: 2 },
  { id: 'n-1772788742481-elrgf', note: 'A4', startStep: 182, durationSteps: 1 },
  { id: 'n-1772788742808-8o8oy', note: 'B4', startStep: 183, durationSteps: 1 },
];

// ── Für Elise — Beethoven, 8 bars ────────────────────────────────────────────
const furEliseNotes: DawNote[] = [
  // Bar 1: opening motif — all 8th notes
  { id: 'fe-1',  note: 'E5',  startStep:  0, durationSteps: 2 },
  { id: 'fe-2',  note: 'D#5', startStep:  2, durationSteps: 2 },
  { id: 'fe-3',  note: 'E5',  startStep:  4, durationSteps: 2 },
  { id: 'fe-4',  note: 'D#5', startStep:  6, durationSteps: 2 },
  { id: 'fe-5',  note: 'E5',  startStep:  8, durationSteps: 2 },
  { id: 'fe-6',  note: 'B4',  startStep: 10, durationSteps: 2 },
  { id: 'fe-7',  note: 'D5',  startStep: 12, durationSteps: 2 },
  { id: 'fe-8',  note: 'C5',  startStep: 14, durationSteps: 2 },
  // Bar 2: A minor arpeggio — A4(q) _ C4 E4 A4 | B4(q) _
  { id: 'fe-9',  note: 'A4',  startStep: 16, durationSteps: 4 },
  { id: 'fe-10', note: 'C4',  startStep: 22, durationSteps: 2 },
  { id: 'fe-11', note: 'E4',  startStep: 24, durationSteps: 2 },
  { id: 'fe-12', note: 'A4',  startStep: 26, durationSteps: 2 },
  { id: 'fe-13', note: 'B4',  startStep: 28, durationSteps: 4 },
  // Bar 3: E minor arpeggio — _ E4 G#4 B4 | C5(q) _
  { id: 'fe-14', note: 'E4',  startStep: 34, durationSteps: 2 },
  { id: 'fe-15', note: 'G#4', startStep: 36, durationSteps: 2 },
  { id: 'fe-16', note: 'B4',  startStep: 38, durationSteps: 2 },
  { id: 'fe-17', note: 'C5',  startStep: 40, durationSteps: 4 },
  // Bar 4: opening motif returns
  { id: 'fe-18', note: 'E5',  startStep: 48, durationSteps: 2 },
  { id: 'fe-19', note: 'D#5', startStep: 50, durationSteps: 2 },
  { id: 'fe-20', note: 'E5',  startStep: 52, durationSteps: 2 },
  { id: 'fe-21', note: 'D#5', startStep: 54, durationSteps: 2 },
  { id: 'fe-22', note: 'E5',  startStep: 56, durationSteps: 2 },
  { id: 'fe-23', note: 'B4',  startStep: 58, durationSteps: 2 },
  { id: 'fe-24', note: 'D5',  startStep: 60, durationSteps: 2 },
  { id: 'fe-25', note: 'C5',  startStep: 62, durationSteps: 2 },
  // Bar 5: A minor resolution — A4(q) _ C4 E4 A4 | E4(q) _
  { id: 'fe-26', note: 'A4',  startStep: 64, durationSteps: 4 },
  { id: 'fe-27', note: 'C4',  startStep: 70, durationSteps: 2 },
  { id: 'fe-28', note: 'E4',  startStep: 72, durationSteps: 2 },
  { id: 'fe-29', note: 'A4',  startStep: 74, durationSteps: 2 },
  { id: 'fe-30', note: 'E4',  startStep: 76, durationSteps: 4 },
  // Bar 6: A minor cadence — A4(q) _ C5 B4 A4 | G4(q) _
  { id: 'fe-31', note: 'A4',  startStep: 80, durationSteps: 4 },
  { id: 'fe-32', note: 'C5',  startStep: 86, durationSteps: 2 },
  { id: 'fe-33', note: 'B4',  startStep: 88, durationSteps: 2 },
  { id: 'fe-34', note: 'A4',  startStep: 90, durationSteps: 2 },
  { id: 'fe-35', note: 'G4',  startStep: 92, durationSteps: 4 },
  // Bar 7: flowing C major passage — ascending then descending 8th notes
  { id: 'fe-36', note: 'C5',  startStep:  96, durationSteps: 2 },
  { id: 'fe-37', note: 'D5',  startStep:  98, durationSteps: 2 },
  { id: 'fe-38', note: 'E5',  startStep: 100, durationSteps: 2 },
  { id: 'fe-39', note: 'G5',  startStep: 102, durationSteps: 2 },
  { id: 'fe-40', note: 'E5',  startStep: 104, durationSteps: 2 },
  { id: 'fe-41', note: 'C5',  startStep: 106, durationSteps: 2 },
  { id: 'fe-42', note: 'D5',  startStep: 108, durationSteps: 2 },
  { id: 'fe-43', note: 'E5',  startStep: 110, durationSteps: 2 },
  // Bar 8: grand resolution with ornamental coda
  { id: 'fe-44', note: 'A4',  startStep: 112, durationSteps: 8 },
  { id: 'fe-45', note: 'A4',  startStep: 120, durationSteps: 4 },
  { id: 'fe-46', note: 'G#4', startStep: 124, durationSteps: 2 },
  { id: 'fe-47', note: 'A4',  startStep: 126, durationSteps: 2 },
  // ── Bass line (left hand — A minor: A2/E3/A3 | E major: E2/B2/E3) ─────────
  { id: 'fe-b-1',  note: 'A2', startStep:   0, durationSteps: 8 },
  { id: 'fe-b-2',  note: 'E3', startStep:   4, durationSteps: 4 },
  { id: 'fe-b-3',  note: 'A3', startStep:   8, durationSteps: 4 },
  { id: 'fe-b-4',  note: 'E3', startStep:  12, durationSteps: 4 },
  { id: 'fe-b-5',  note: 'A2', startStep:  16, durationSteps: 8 },
  { id: 'fe-b-6',  note: 'E3', startStep:  16, durationSteps: 4 },
  { id: 'fe-b-7',  note: 'C3', startStep:  22, durationSteps: 2 },
  { id: 'fe-b-8',  note: 'E3', startStep:  24, durationSteps: 4 },
  { id: 'fe-b-9',  note: 'E2', startStep:  28, durationSteps: 4 },
  { id: 'fe-b-10', note: 'E2', startStep:  32, durationSteps: 8 },
  { id: 'fe-b-11', note: 'B2', startStep:  36, durationSteps: 4 },
  { id: 'fe-b-12', note: 'E3', startStep:  40, durationSteps: 4 },
  { id: 'fe-b-13', note: 'B2', startStep:  44, durationSteps: 4 },
  { id: 'fe-b-14', note: 'A2', startStep:  48, durationSteps: 8 },
  { id: 'fe-b-15', note: 'E3', startStep:  52, durationSteps: 4 },
  { id: 'fe-b-16', note: 'A3', startStep:  56, durationSteps: 4 },
  { id: 'fe-b-17', note: 'E3', startStep:  60, durationSteps: 4 },
  { id: 'fe-b-18', note: 'A2', startStep:  64, durationSteps: 8 },
  { id: 'fe-b-19', note: 'E3', startStep:  64, durationSteps: 4 },
  { id: 'fe-b-20', note: 'C3', startStep:  70, durationSteps: 2 },
  { id: 'fe-b-21', note: 'E3', startStep:  72, durationSteps: 4 },
  { id: 'fe-b-22', note: 'E2', startStep:  76, durationSteps: 4 },
  { id: 'fe-b-23', note: 'A2', startStep:  80, durationSteps: 8 },
  { id: 'fe-b-24', note: 'E3', startStep:  80, durationSteps: 4 },
  { id: 'fe-b-25', note: 'A3', startStep:  88, durationSteps: 4 },
  { id: 'fe-b-26', note: 'D3', startStep:  92, durationSteps: 4 },
  { id: 'fe-b-27', note: 'C3', startStep:  96, durationSteps: 4 },
  { id: 'fe-b-28', note: 'G3', startStep: 100, durationSteps: 4 },
  { id: 'fe-b-29', note: 'E3', startStep: 104, durationSteps: 4 },
  { id: 'fe-b-30', note: 'G3', startStep: 108, durationSteps: 4 },
  { id: 'fe-b-31', note: 'A2', startStep: 112, durationSteps: 16 },
  { id: 'fe-b-32', note: 'E3', startStep: 112, durationSteps: 8 },
  { id: 'fe-b-33', note: 'A3', startStep: 120, durationSteps: 8 },
  // ── Inner voices, harmonies & ornamentation ───────────────────────────────
  { id: 'fe-m-1',  note: 'E4', startStep:  18, durationSteps: 2 },
  { id: 'fe-m-2',  note: 'C4', startStep:  20, durationSteps: 2 },
  { id: 'fe-m-3',  note: 'A3', startStep:  32, durationSteps: 1 },
  { id: 'fe-m-4',  note: 'B3', startStep:  33, durationSteps: 1 },
  { id: 'fe-m-5',  note: 'E4', startStep:  66, durationSteps: 2 },
  { id: 'fe-m-6',  note: 'C4', startStep:  68, durationSteps: 2 },
  { id: 'fe-m-7',  note: 'E4', startStep:  82, durationSteps: 2 },
  { id: 'fe-m-8',  note: 'F4', startStep:  84, durationSteps: 2 },
  { id: 'fe-m-9',  note: 'E4', startStep:  86, durationSteps: 2 },
  { id: 'fe-m-10', note: 'D4', startStep:  90, durationSteps: 2 },
  { id: 'fe-m-11', note: 'E4', startStep:  96, durationSteps: 4 },
  { id: 'fe-m-12', note: 'G4', startStep: 100, durationSteps: 4 },
  { id: 'fe-m-13', note: 'E4', startStep: 104, durationSteps: 4 },
  { id: 'fe-m-14', note: 'D4', startStep: 108, durationSteps: 4 },
  { id: 'fe-m-15', note: 'E4', startStep: 116, durationSteps: 4 },
  { id: 'fe-m-16', note: 'C4', startStep: 120, durationSteps: 8 },
];

// ── Ode to Joy — Beethoven, 8 bars (two full phrases) ────────────────────────
const odeToJoyNotes: DawNote[] = [
  { id: 'oj-1',  note: 'E4', startStep:   0, durationSteps: 4 },
  { id: 'oj-2',  note: 'E4', startStep:   4, durationSteps: 4 },
  { id: 'oj-3',  note: 'F4', startStep:   8, durationSteps: 4 },
  { id: 'oj-4',  note: 'G4', startStep:  12, durationSteps: 4 },
  { id: 'oj-5',  note: 'G4', startStep:  16, durationSteps: 4 },
  { id: 'oj-6',  note: 'F4', startStep:  20, durationSteps: 4 },
  { id: 'oj-7',  note: 'E4', startStep:  24, durationSteps: 4 },
  { id: 'oj-8',  note: 'D4', startStep:  28, durationSteps: 4 },
  { id: 'oj-9',  note: 'C4', startStep:  32, durationSteps: 4 },
  { id: 'oj-10', note: 'C4', startStep:  36, durationSteps: 4 },
  { id: 'oj-11', note: 'D4', startStep:  40, durationSteps: 4 },
  { id: 'oj-12', note: 'E4', startStep:  44, durationSteps: 4 },
  { id: 'oj-13', note: 'E4', startStep:  48, durationSteps: 6 },
  { id: 'oj-14', note: 'D4', startStep:  54, durationSteps: 2 },
  { id: 'oj-15', note: 'D4', startStep:  56, durationSteps: 8 },
  { id: 'oj-16', note: 'D4', startStep:  64, durationSteps: 4 },
  { id: 'oj-17', note: 'D4', startStep:  68, durationSteps: 4 },
  { id: 'oj-18', note: 'E4', startStep:  72, durationSteps: 4 },
  { id: 'oj-19', note: 'C4', startStep:  76, durationSteps: 4 },
  { id: 'oj-20', note: 'D4', startStep:  80, durationSteps: 4 },
  { id: 'oj-21', note: 'E4', startStep:  84, durationSteps: 2 },
  { id: 'oj-22', note: 'F4', startStep:  86, durationSteps: 2 },
  { id: 'oj-23', note: 'E4', startStep:  88, durationSteps: 4 },
  { id: 'oj-24', note: 'C4', startStep:  92, durationSteps: 4 },
  { id: 'oj-25', note: 'D4', startStep:  96, durationSteps: 4 },
  { id: 'oj-26', note: 'E4', startStep: 100, durationSteps: 2 },
  { id: 'oj-27', note: 'F4', startStep: 102, durationSteps: 2 },
  { id: 'oj-28', note: 'E4', startStep: 104, durationSteps: 4 },
  { id: 'oj-29', note: 'D4', startStep: 108, durationSteps: 4 },
  { id: 'oj-30', note: 'C4', startStep: 112, durationSteps: 4 },
  { id: 'oj-31', note: 'D4', startStep: 116, durationSteps: 4 },
  { id: 'oj-32', note: 'G4', startStep: 120, durationSteps: 8 },
  { id: 'oj-b-8',  note: 'G3', startStep:  28, durationSteps: 4 },
  { id: 'oj-b-13', note: 'G3', startStep:  48, durationSteps: 6 },
  { id: 'oj-b-14', note: 'G3', startStep:  54, durationSteps: 2 },
  { id: 'oj-b-15', note: 'C3', startStep:  56, durationSteps: 8 },
  { id: 'oj-b-16', note: 'G3', startStep:  64, durationSteps: 4 },
  { id: 'oj-b-17', note: 'G3', startStep:  68, durationSteps: 4 },
  { id: 'oj-b-18', note: 'C3', startStep:  72, durationSteps: 4 },
  { id: 'oj-b-19', note: 'C3', startStep:  76, durationSteps: 4 },
  { id: 'oj-b-20', note: 'G3', startStep:  80, durationSteps: 4 },
  { id: 'oj-b-21', note: 'G3', startStep:  84, durationSteps: 2 },
  { id: 'oj-b-22', note: 'F3', startStep:  86, durationSteps: 2 },
  { id: 'oj-b-23', note: 'C3', startStep:  88, durationSteps: 4 },
  { id: 'oj-b-24', note: 'C3', startStep:  92, durationSteps: 4 },
  { id: 'oj-b-25', note: 'G3', startStep:  96, durationSteps: 4 },
  { id: 'oj-b-26', note: 'G3', startStep: 100, durationSteps: 4 },
  { id: 'oj-b-27', note: 'G3', startStep: 104, durationSteps: 4 },
  { id: 'oj-b-28', note: 'D3', startStep: 108, durationSteps: 4 },
  { id: 'oj-b-29', note: 'C3', startStep: 112, durationSteps: 4 },
  { id: 'oj-b-30', note: 'G3', startStep: 116, durationSteps: 4 },
  { id: 'oj-b-31', note: 'C3', startStep: 120, durationSteps: 8 },
  { id: 'oj-h-1',  note: 'C4', startStep:   0, durationSteps: 4 },
  { id: 'oj-h-2',  note: 'C4', startStep:   4, durationSteps: 4 },
  { id: 'oj-h-3',  note: 'D4', startStep:   8, durationSteps: 4 },
  { id: 'oj-h-4',  note: 'E4', startStep:  12, durationSteps: 4 },
  { id: 'oj-h-5',  note: 'E4', startStep:  16, durationSteps: 4 },
  { id: 'oj-h-6',  note: 'D4', startStep:  20, durationSteps: 4 },
  { id: 'oj-h-7',  note: 'C4', startStep:  24, durationSteps: 4 },
  { id: 'oj-h-8',  note: 'B3', startStep:  28, durationSteps: 4 },
  { id: 'oj-h-9',  note: 'A3', startStep:  32, durationSteps: 4 },
  { id: 'oj-h-10', note: 'A3', startStep:  36, durationSteps: 4 },
  { id: 'oj-h-11', note: 'B3', startStep:  40, durationSteps: 4 },
  { id: 'oj-h-12', note: 'C4', startStep:  44, durationSteps: 4 },
  { id: 'oj-h-13', note: 'C4', startStep:  48, durationSteps: 6 },
  { id: 'oj-h-14', note: 'B3', startStep:  54, durationSteps: 2 },
  { id: 'oj-h-15', note: 'B3', startStep:  56, durationSteps: 8 },
  { id: 'oj-h-16', note: 'B3', startStep:  64, durationSteps: 4 },
  { id: 'oj-h-17', note: 'B3', startStep:  68, durationSteps: 4 },
  { id: 'oj-h-18', note: 'C4', startStep:  72, durationSteps: 4 },
  { id: 'oj-h-19', note: 'A3', startStep:  76, durationSteps: 4 },
  { id: 'oj-h-20', note: 'B3', startStep:  80, durationSteps: 4 },
  { id: 'oj-h-21', note: 'C4', startStep:  84, durationSteps: 2 },
  { id: 'oj-h-22', note: 'D4', startStep:  86, durationSteps: 2 },
  { id: 'oj-h-23', note: 'C4', startStep:  88, durationSteps: 4 },
  { id: 'oj-h-24', note: 'A3', startStep:  92, durationSteps: 4 },
  { id: 'oj-h-25', note: 'B3', startStep:  96, durationSteps: 4 },
  { id: 'oj-h-26', note: 'C4', startStep: 100, durationSteps: 2 },
  { id: 'oj-h-27', note: 'D4', startStep: 102, durationSteps: 2 },
  { id: 'oj-h-28', note: 'C4', startStep: 104, durationSteps: 4 },
  { id: 'oj-h-29', note: 'B3', startStep: 108, durationSteps: 4 },
  { id: 'oj-h-30', note: 'A3', startStep: 112, durationSteps: 4 },
  { id: 'oj-h-31', note: 'B3', startStep: 116, durationSteps: 4 },
  { id: 'oj-h-32', note: 'E4', startStep: 120, durationSteps: 8 },
  { id: 'oj-o-1', note: 'A3', startStep:  60, durationSteps: 1 },
  { id: 'oj-o-2', note: 'B3', startStep:  61, durationSteps: 1 },
  { id: 'oj-o-3', note: 'C4', startStep:  62, durationSteps: 1 },
  { id: 'oj-o-4', note: 'D4', startStep:  63, durationSteps: 1 },
  { id: 'oj-o-5', note: 'F3', startStep: 109, durationSteps: 1 },
  { id: 'oj-o-6', note: 'G3', startStep: 110, durationSteps: 1 },
  { id: 'oj-o-7', note: 'A3', startStep: 111, durationSteps: 1 },
  { id: 'n-1772790546437-rl4aj', note: 'E6', startStep:   2, durationSteps: 1 },
  { id: 'n-1772790548565-pumrd', note: 'E6', startStep:   0, durationSteps: 1 },
  { id: 'n-1772790549707-2onsy', note: 'E6', startStep:   4, durationSteps: 1 },
  { id: 'n-1772790550329-zw4qy', note: 'E6', startStep:   6, durationSteps: 1 },
  { id: 'n-1772790550952-efl2c', note: 'F6', startStep:   8, durationSteps: 2 },
  { id: 'n-1772790570249-mnow2', note: 'G6', startStep:  12, durationSteps: 2 },
  { id: 'n-1772790584458-ne5k3', note: 'G6', startStep:  16, durationSteps: 1 },
  { id: 'n-1772790601018-83wht', note: 'G5', startStep:  20, durationSteps: 1 },
  { id: 'n-1772790610348-i9s12', note: 'C5', startStep:  24, durationSteps: 1 },
  { id: 'n-1772790611554-fqwdu', note: 'D5', startStep:  25, durationSteps: 1 },
  { id: 'n-1772790612394-6zi5u', note: 'E5', startStep:  26, durationSteps: 1 },
  { id: 'n-1772790614533-kgk3q', note: 'F5', startStep:  27, durationSteps: 1 },
  { id: 'n-1772790615117-o18nc', note: 'E5', startStep:  28, durationSteps: 2 },
  { id: 'n-1772790617179-7oz6y', note: 'D5', startStep:  30, durationSteps: 2 },
  { id: 'n-1772790625760-73b99', note: 'G5', startStep:  32, durationSteps: 2 },
  { id: 'n-1772790628071-jfd61', note: 'A5', startStep:  34, durationSteps: 2 },
  { id: 'n-1772790631895-hrw3u', note: 'B5', startStep:  36, durationSteps: 2 },
  { id: 'n-1772790633080-lxryj', note: 'C6', startStep:  38, durationSteps: 2 },
  { id: 'n-1772790634235-j5sj2', note: 'D6', startStep:  40, durationSteps: 2 },
  { id: 'n-1772790635749-i1cfu', note: 'E6', startStep:  42, durationSteps: 2 },
  { id: 'n-1772790637126-xtn7r', note: 'F6', startStep:  44, durationSteps: 2 },
  { id: 'n-1772790638706-myxoi', note: 'G6', startStep:  46, durationSteps: 2 },
  { id: 'n-1772790662412-lb4zb', note: 'G5', startStep:  18, durationSteps: 1 },
  { id: 'n-1772790666514-l3155', note: 'A5', startStep:  22, durationSteps: 1 },
  { id: 'n-1772790855760-hmw93', note: 'G5', startStep:  48, durationSteps: 4 },
  { id: 'n-1772790857294-xfzsa', note: 'A5', startStep:  52, durationSteps: 4 },
  { id: 'n-1772790860236-k3k4x', note: 'B5', startStep:  57, durationSteps: 3 },
  { id: 'n-1772790860709-dffp8', note: 'A#5', startStep: 56, durationSteps: 1 },
  { id: 'n-1772790868683-iqxff', note: 'C6', startStep:  60, durationSteps: 1 },
  { id: 'n-1772790870588-vdipm', note: 'B5', startStep:  61, durationSteps: 3 },
  { id: 'n-1772790893961-u2pq8', note: 'D6', startStep:  64, durationSteps: 1 },
  { id: 'n-1772790895856-an2lc', note: 'G6', startStep:  66, durationSteps: 1 },
  { id: 'n-1772790952926-v43gv', note: 'D6', startStep:  68, durationSteps: 1 },
  { id: 'n-1772790953699-09c7k', note: 'G6', startStep:  70, durationSteps: 1 },
  { id: 'n-1772790958769-6r0i5', note: 'G5', startStep:  72, durationSteps: 1 },
  { id: 'n-1772790959818-ow3ak', note: 'C6', startStep:  74, durationSteps: 1 },
  { id: 'n-1772790961025-5ex4f', note: 'G5', startStep:  76, durationSteps: 1 },
  { id: 'n-1772790961813-yhw7c', note: 'C6', startStep:  78, durationSteps: 1 },
  { id: 'n-1772790965812-3lkyk', note: 'F6', startStep:  80, durationSteps: 2 },
  { id: 'n-1772790981360-kavhr', note: 'E6', startStep:  84, durationSteps: 2 },
  { id: 'n-1772790983458-17hnc', note: 'D6', startStep:  88, durationSteps: 2 },
  { id: 'n-1772790985082-p53jx', note: 'C6', startStep:  92, durationSteps: 2 },
  { id: 'n-1772790990018-0zlvy', note: 'D7', startStep:  96, durationSteps: 1 },
  { id: 'n-1772790992924-p0awr', note: 'C7', startStep:  97, durationSteps: 1 },
  { id: 'n-1772790993638-tjj5n', note: 'B6', startStep:  98, durationSteps: 1 },
  { id: 'n-1772790994285-4y638', note: 'A6', startStep:  99, durationSteps: 1 },
  { id: 'n-1772790995328-vwnep', note: 'G6', startStep: 100, durationSteps: 4 },
  { id: 'n-1772790997567-6tyyq', note: 'A6', startStep: 104, durationSteps: 1 },
  { id: 'n-1772790999654-kducz', note: 'G6', startStep: 106, durationSteps: 1 },
  { id: 'n-1772791000606-gbork', note: 'E6', startStep: 108, durationSteps: 1 },
  { id: 'n-1772791002765-qwzcr', note: 'D6', startStep: 110, durationSteps: 2 },
  { id: 'n-1772791017054-jis71', note: 'G7', startStep: 112, durationSteps: 1 },
  { id: 'n-1772791019117-088cl', note: 'A7', startStep: 114, durationSteps: 1 },
  { id: 'n-1772791020152-in2id', note: 'G7', startStep: 116, durationSteps: 1 },
  { id: 'n-1772791020940-6q749', note: 'A7', startStep: 118, durationSteps: 1 },
  { id: 'n-1772791021697-2tkcr', note: 'G7', startStep: 120, durationSteps: 8 },
];

const SAVED_AT = new Date('2025-01-01').getTime();

export const DEFAULT_PROJECTS: Project[] = [
  {
    id: 'default-twinkle',
    name: 'Twinkle Twinkle Little Star',
    savedAt: SAVED_AT,
    bpm: 100,
    measures: 12,
    loop: true,
    notes: twinkleNotes,
    oscillators: [
      {
        id: 'def-tt-osc',
        waveType: 'triangle',
        attack: 0.01,
        decay: 0.15,
        sustain: 0.3,
        release: 0.25,
        volume: -8,
        transpose: 0,
        enabled: true,
        filterType: 'off' as const,
        filterFrequency: 2000,
        filterQ: 1,
      },
      {
        id: 'osc-mmeoq9myrsgd',
        waveType: 'sine',
        attack: 0.191,
        decay: 0.1,
        sustain: 0.19,
        release: 2.273,
        volume: -20,
        transpose: -12,
        enabled: true,
        filterType: 'off' as const,
        filterFrequency: 2000,
        filterQ: 1,
      },
    ],
  },
  {
    id: 'default-fur-elise',
    name: 'Für Elise — Beethoven',
    savedAt: SAVED_AT,
    bpm: 130,
    measures: 8,
    loop: true,
    notes: furEliseNotes,
    oscillators: [
      {
        id: 'def-fe-osc',
        waveType: 'sine',
        attack: 0.01,
        decay: 0.12,
        sustain: 0.6,
        release: 0.5,
        volume: -6,
        transpose: 0,
        enabled: true,
        filterType: 'off' as const,
        filterFrequency: 2000,
        filterQ: 1,
      },
      {
        id: 'def-fe-osc-2',
        waveType: 'triangle',
        attack: 0.08,
        decay: 0.2,
        sustain: 0.55,
        release: 1.8,
        volume: -16,
        transpose: -12,
        enabled: true,
        filterType: 'off' as const,
        filterFrequency: 2000,
        filterQ: 1,
      },
    ],
  },
  {
    id: 'default-ode-to-joy',
    name: 'Ode to Joy — Beethoven',
    savedAt: SAVED_AT,
    bpm: 110,
    measures: 8,
    loop: true,
    notes: odeToJoyNotes,
    oscillators: [
      {
        id: 'def-oj-osc',
        waveType: 'square',
        attack: 0.428,
        decay: 1.131,
        sustain: 0.34,
        release: 0.87,
        volume: -22.5,
        transpose: 0,
        enabled: true,
        filterType: 'lowpass' as const,
        filterFrequency: 10280,
        filterQ: 3.8,
      },
      {
        id: 'def-oj-osc-2',
        waveType: 'sine',
        attack: 0.05,
        decay: 0.15,
        sustain: 0.6,
        release: 1.2,
        volume: -14,
        transpose: -12,
        enabled: true,
        filterType: 'off' as const,
        filterFrequency: 2000,
        filterQ: 1,
      },
    ],
  },
];
